export const SET_DEFAULT_INVOICE_TEMPLATE = "SET_DEFAULT_INVOICE_TEMPLATE";
export const SET_DEFAULT_VOUCHER_TEMPLATE = "SET_DEFAULT_VOUCHER_TEMPLATE";
export const GET_DEFAULT_INVOICE_TEMPLATE = "GET_DEFAULT_INVOICE_TEMPLATE";
export const SET_REFRESH_DATA_TABLE = "SET_REFRESH_DATA_TABLE";
